import React from 'react';
import { cn, getStatusColor, getStatusLabel } from '../../lib/utils';

export function StatusBadge({ status, className }) {
    return (
        <span
            className={cn(
                'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
                getStatusColor(status),
                className
            )}
            data-testid={`status-badge-${status}`}
        >
            {getStatusLabel(status)}
        </span>
    );
}
